import "./navigation-divider.css";

export const NavigationDivider: React.FC = () => {
  return <hr />
}